import { useSelector } from "react-redux";
import { useFlightUpSellData } from "./useFlightUpSellData";
import { Experiments, useExperiment } from "@/modules/experiments/src";
import type { RootState } from "@/store";
import { selectUpSellIneligibleReason } from "@/tracking/upSell/upSellEligibility";
import { useIsExchangeFlow } from "@/utilities/flights/useIsExchangeFlow";

/**
 * Single source of truth for whether the stays up-sell can show, shared by
 * every entry point (inline banner, sticky bar, interstitial).
 */
export const useStaysUpsellEligibility = () => {
  const { getExperimentVariant } = useExperiment();
  const variant = getExperimentVariant(
    Experiments.UPSELL_STAYS_FROM_FLIGHTS.name
  );
  const variants = Experiments.UPSELL_STAYS_FROM_FLIGHTS.variants;
  const isExchange = useIsExchangeFlow();
  const flightUpSellData = useFlightUpSellData();

  // Same selector viewed_trip_summary reports as up_sell_eligible.
  const ineligibleReason = useSelector((state: RootState) =>
    selectUpSellIneligibleReason(state, isExchange)
  );

  const isEnabled =
    variant != null &&
    variant !== variants.control &&
    flightUpSellData != null &&
    ineligibleReason == null;

  return { variant, variants, isEnabled, flightUpSellData };
};
